module.exports = __webpack_public_path__ + "img/full4-min.a1b16ad0.png";